import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { mapActions as mapPiniaActions, mapStores as mapPiniaStores } from 'pinia';
import { mapGetters } from 'vuex';
import componentI18n from '@/i18n/componentI18n';
import router from '@/router';
import Scaffold from '@/components/Scaffold.vue';
import Content from '@/components/retro_show_layout/Content.vue';
import Floating from '@/components/retro_show_layout/Floating.vue';
import Footer from '@/components/retro_show_layout/Footer.vue';
import Sidebar from '@/components/retro_show_layout/Sidebar.vue';
import Subheader from '@/components/retro_show_layout/Subheader.vue';
import FloatingContent from '@/components/retro_show_layout/FloatingContent.vue';
import { useRetroStore } from '@/pinia_stores/retro';
const __default__ = {
    components: {
        Content,
        Floating,
        FloatingContent,
        Footer,
        Scaffold,
        Sidebar,
        Subheader
    },
    ...componentI18n('views.retro.show'),
    data() {
        return {
            retroId: this.$route.params.retroId
        };
    },
    computed: {
        ...mapPiniaStores(useRetroStore),
        ...mapGetters(['loggedIn', 'verified', 'temporary'])
    },
    watch: {
        $route() {
            this.retroId = this.$route.params.retroId;
            this.init();
        }
    },
    beforeUnmount() {
        this.leave();
        this.retroStore.$reset();
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapPiniaActions(useRetroStore, ['join', 'leave']),
        init() {
            // TODO(UPGRADE): $route watch is activated when going to home.
            // I feel like that watch is unnecessary and we should only use
            // mount/unmount logic but for now, checking for retroId undefined will
            // do the trick in a safe way.
            if (this.retroId && this.loggedIn && this.verified && !this.temporary) {
                this.join(this.retroId);
            }
            else if (this.temporary) {
                router.push({ name: 'completeAccount' });
            }
            else if (!this.verified) {
                router.push({ name: 'checkYourInbox' });
            }
        }
    }
};
import { onMounted, ref } from 'vue';
import { useFullWidth } from '@/composables/useFullWidth';
import { useWorkspaceAndTeam } from '@/composables/workspaces';
import { useConstantStore } from '@/pinia_stores/constant';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Show',
    setup(__props) {
        useFullWidth();
        useWorkspaceAndTeam({ loadFullWorkspace: true });
        const constantStore = useConstantStore();
        const areActivitiesLoaded = ref(false);
        const isFreeIceBreakerModalOpen = ref(false);
        onMounted(async () => {
            await constantStore.loadActivities();
            areActivitiesLoaded.value = true;
        });
        function handleFreeIceBreak() {
            isFreeIceBreakerModalOpen.value = true;
        }
        return (_ctx, _cache) => {
            return (areActivitiesLoaded.value)
                ? (_openBlock(), _createBlock(Scaffold, {
                    key: 0,
                    class: "h-screen pt-10"
                }, {
                    subheader: _withCtx(() => [
                        _createVNode(Subheader)
                    ]),
                    sidebar: _withCtx(() => [
                        _createVNode(Sidebar, {
                            class: "flex-1",
                            onFreeIceBreak: handleFreeIceBreak
                        })
                    ]),
                    content: _withCtx(() => [
                        _createVNode(Content, {
                            class: "flex-1",
                            "is-free-ice-breaker-modal-open": isFreeIceBreakerModalOpen.value,
                            "onUpdate:is-free-ice-breaker-modal-open": _cache[0] || (_cache[0] = ($event) => ((isFreeIceBreakerModalOpen).value = $event))
                        }, null, 8, ["is-free-ice-breaker-modal-open"])
                    ]),
                    "floating-content": _withCtx(() => [
                        _createVNode(FloatingContent)
                    ]),
                    footer: _withCtx(() => [
                        _createVNode(Footer)
                    ]),
                    floating: _withCtx(() => [
                        _createVNode(Floating)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
